<style scoped>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}
.required_err {
  color: rgba(255, 0, 0);
}

.rc_td_bottom {
    border-top: none !important;
    border-right: none !important;
    border-left: none !important;
    border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

.rc_td_no_borders {
    border-top: none !important;
    border-right: none !important;
    border-left: none !important;
    border-bottom: none !important;
}

tr:hover {
    background-color: transparent !important;
}

.br_rd_odd {
    background-color: rgba(0, 0, 0, .03) !important;
}

.rc_section {
    padding-top: 12px;
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>
    <div class="ip_pool">
        <v-toolbar flat>
            <v-toolbar-title><h2 class="br">IP pools</h2></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="show_new_ip_pool_form"
                    color="primary" dark class="mb-2">
                    Add IP pool
            </v-btn>
        </v-toolbar>

        <v-simple-table>
            <template v-slot:default>

<v-dialog v-model="dialog" max-width="600px">
    <ValidationObserver ref="edit_ip_pool_observer" v-slot="{ invalid }">
    <v-card>
        <v-card-title>
            <span class="headline">IP pool '{{ edited_item.name }}'</span>
        </v-card-title>

        <v-card-text>
            <v-container style="height: 520px; overflow-y: scroll;">
                <v-row>
                    <v-col cols="12">
                        <div class="rc_section">
                            <v-toolbar flat>
                                <v-toolbar-title>IP ranges</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn @click="show_ip_range_form()">Add</v-btn>
                            </v-toolbar>
                            <v-data-table
                                    :headers="ip_range_hdrs"
                                    :items="edited_item.ip_ranges"
                                    sort-by="from"
                                    hide-default-footer
                                    class="elevation-1">

                                <template v-slot:item.actions="{ item }">
                                    <v-icon small @click="before_ip_range_delete(item)">
                                        mdi-delete
                                    </v-icon>
                                </template>
                            </v-data-table>
                        </div>

                        <div class="rc_section">
                            <v-toolbar flat>
                                    <v-toolbar-title>DHCP options</v-toolbar-title>
                                    <v-spacer></v-spacer>
                            </v-toolbar>

                            <ValidationProvider rules="ipv4_addr_optional" v-slot="{ errors }">
                                <v-text-field
                                    v-model="edited_item.dhcp_options.router"
                                    label="Router (optional)">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>

                            <ValidationProvider rules="numeric" v-slot="{ errors }">
                                <v-text-field
                                    v-model="edited_item.dhcp_options.mask"
                                    label="Netmask (optional)">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>

                            <ValidationProvider rules="numeric" v-slot="{ errors }">
                                <v-text-field
                                    v-model="edited_item.dhcp_options.lease_time"
                                    label="Lease time (optional)">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>

                            <ValidationProvider rules="ipv4_addr_optional" v-slot="{ errors }">
                                <v-text-field
                                    v-model="edited_item.dhcp_options.broadcast"
                                    label="Broadcast (optional)">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>

                            <ValidationProvider rules="numeric" v-slot="{ errors }">
                                <v-text-field
                                    v-model="edited_item.dhcp_options.mtu"
                                    label="MTU (optional)">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>

                            <div class="rc_section">
                                <v-toolbar flat>
                                    <v-toolbar-title>DNS servers</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="add_dns()">Add</v-btn>
                                </v-toolbar>
                                <v-data-table
                                        :headers="server_hdrs"
                                        :items="edited_item.dhcp_options.dns"
                                        sort-by="ip"
                                        hide-default-footer
                                        class="elevation-1">
                                    <template v-slot:item.actions="{ item }">
                                        <v-icon small @click="before_del_dns(item)">
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                    <template v-slot:no-data>
                                        No records
                                    </template>
                                </v-data-table>
                            </div>

                            <div class="rc_section">
                                <v-toolbar flat>
                                    <v-toolbar-title>NTP servers</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="add_ntp()">Add</v-btn>
                                </v-toolbar>
                                <v-data-table
                                        :headers="server_hdrs"
                                        :items="edited_item.dhcp_options.ntp"
                                        sort-by="ip"
                                        hide-default-footer
                                        class="elevation-1">
                                    <template v-slot:item.actions="{ item }">
                                        <v-icon small @click="before_del_ntp(item)">
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                    <template v-slot:no-data>
                                        No records
                                    </template>
                                </v-data-table>
                            </div>
                            
                            <div class="rc_section">
                                <v-toolbar flat>
                                    <v-toolbar-title>NBNS servers</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-btn @click="add_nbns()">Add</v-btn>
                                </v-toolbar>
                                <v-data-table
                                        :headers="server_hdrs"
                                        :items="edited_item.dhcp_options.nbns"
                                        sort-by="ip"
                                        hide-default-footer
                                        class="elevation-1">
                                    <template v-slot:item.actions="{ item }">
                                        <v-icon small @click="before_del_nbns(item)">
                                            mdi-delete
                                        </v-icon>
                                    </template>
                                    <template v-slot:no-data>
                                        No records
                                    </template>
                                </v-data-table>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" :disabled="invalid" text @click="save">Save</v-btn>
            <v-btn color="blue darken-1" text @click="close">Close</v-btn>
        </v-card-actions>
    </v-card>
    </ValidationObserver>
</v-dialog>

<v-dialog v-model="new_server_dialog" max-width="500px">
    <ValidationObserver ref="new_server_observer" v-slot="{ invalid }">
        <v-card>
            <v-card-title>
                <span class="headline">Add a new {{ server_type }} server to IP pool '{{ edited_item.name }}'</span>
            </v-card-title>
            <v-card-text>
                <v-container style="height: 520px; overflow-y: scroll;">
                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider rules="required|ipv4_addr" v-slot="{ errors }">
                                <v-text-field
                                    v-model="server_ip"
                                    label="IP address">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </v-col>
                    </v-row>  
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="new_server_form__close">
                    Cancel</v-btn>
                <v-btn color="blue darken-1" :disabled="invalid"
                        text @click="new_server_form__save">
                    Save</v-btn>
            </v-card-actions>
        </v-card>
    </ValidationObserver>
</v-dialog>

<v-dialog v-model="new_ip_pool_dialog" max-width="500px">
    <ValidationObserver ref="new_ip_pool_observer" v-slot="{ invalid }">
        <v-card>
            <v-card-title>
                <span class="headline">Add a new IP pool</span>
            </v-card-title>
            <v-card-text>
                <v-container style="height: 520px; overflow-y: scroll;">
                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <v-text-field
                                    v-model="ip_pool_name"
                                    label="IP pool name">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </v-col>
                    </v-row>  
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="new_ip_pool_form__close">
                    Cancel</v-btn>
                <v-btn color="blue darken-1" :disabled="invalid"
                        text @click="new_ip_pool_form__save">
                    Save</v-btn>
            </v-card-actions>
        </v-card>
    </ValidationObserver>
</v-dialog>

<v-dialog v-model="new_ip_range_dialog" max-width="500px">
    <ValidationObserver ref="new_ip_range_observer" v-slot="{ invalid }">
        <v-card>
            <v-card-title>
                <span class="headline">Add a new IP range to pool '{{ edited_item.name }}'</span>
            </v-card-title>
            <v-card-text>
                <v-container style="height: 520px; overflow-y: scroll;">
                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider rules="required|ipv4_addr" v-slot="{ errors }">
                                <v-text-field
                                    v-model="from"
                                    label="From IP address">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>

                            <ValidationProvider rules="required|ipv4_addr" v-slot="{ errors }">
                                <v-text-field
                                    v-model="to"
                                    label="To IP address">
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>                            
                        </v-col>
                    </v-row>  
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="new_ip_range_form__close">
                    Cancel</v-btn>
                <v-btn color="blue darken-1" :disabled="invalid"
                        text @click="new_ip_range_form__save">
                    Save</v-btn>
            </v-card-actions>
        </v-card>
    </ValidationObserver>
</v-dialog>

            <thead>
                <tr>
                    <th class="text-left">
                        Name
                    </th>
                    <th class="text-left">
                        IP ranges
                    </th>
                    <th class="text-left">
                        Router
                    </th>
                    <th class="text-left">
                        Netmask
                    </th>
                    <th class="text-left">
                        Lease time
                    </th>
                    <th class="text-left">
                        MTU
                    </th>
                    <th class="text-left">
                        Broadcast
                    </th>
                    <th class="text-left">
                        DNS
                    </th>
                    <th class="text-left">
                        NTP
                    </th>
                    <th class="text-left">
                        NBNS
                    </th>
                    <th class="text-left">
                        Actions
                    </th>
                </tr>
            </thead>
            <tbody>
                <template v-for="pool,row_ind in items">
                    <tr v-for="(n,ind) in pool.num_rows" :key="pool.name + ':' + n">
                        <td v-if="ind == 0" :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(pool)" 
                            :rowspan="pool.num_rows">{{ pool.name }}</td>

                        <td :class="tbl_td_class(pool, ind, row_ind)" v-if="pool.ip_ranges[ind] !== undefined"
                                @dblclick="edit_item(pool)">
                            {{ pool.ip_ranges[ind].from }} - {{ pool.ip_ranges[ind].to }}
                        </td>
                        <td :class="tbl_td_class(pool, ind, row_ind)" @dblclick="edit_item(pool)" v-else></td>

                        <td v-if="ind == 0 && pool.dhcp_options != undefined && pool.dhcp_options.router!= undefined"
                            :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(pool)" 
                            :rowspan="pool.num_rows">{{ pool.dhcp_options.router }}</td>
                        <td v-else-if="ind == 0" :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(pool)" 
                            :rowspan="pool.num_rows"></td>

                        <td v-if="ind == 0 && pool.dhcp_options != undefined && pool.dhcp_options.mask != undefined"
                            :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(pool)" 
                            :rowspan="pool.num_rows">{{ pool.dhcp_options.mask }}</td>
                        <td v-else-if="ind == 0" :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(pool)" 
                            :rowspan="pool.num_rows"></td>

                        <td v-if="ind == 0 && pool.dhcp_options != undefined && pool.dhcp_options.lease_time != undefined"
                            :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(pool)" 
                            :rowspan="pool.num_rows">{{ pool.dhcp_options.lease_time }}</td>
                        <td v-else-if="ind == 0" :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(pool)" 
                            :rowspan="pool.num_rows"></td>

                        <td v-if="ind == 0 && pool.dhcp_options != undefined && pool.dhcp_options.mtu != undefined"
                            :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(pool)" 
                            :rowspan="pool.num_rows">{{ pool.dhcp_options.mtu }}</td>
                        <td v-else-if="ind == 0" :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(pool)" 
                            :rowspan="pool.num_rows"></td>

                        <td v-if="ind == 0 && pool.dhcp_options != undefined && pool.dhcp_options.broadcast != undefined"
                            :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(pool)" 
                            :rowspan="pool.num_rows">{{ pool.dhcp_options.broadcast }}</td>
                        <td v-else-if="ind == 0" :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" @dblclick="edit_item(pool)" 
                            :rowspan="pool.num_rows"></td>

                        <td :class="tbl_td_class(pool, ind, row_ind)" 
                                v-if="pool.dhcp_options !== undefined && pool.dhcp_options.dns[ind] !== undefined"
                                @dblclick="edit_item(pool)">
                            {{ pool.dhcp_options.dns[ind].ip }}
                        </td>
                        <td :class="tbl_td_class(pool, ind, row_ind)" @dblclick="edit_item(pool)" v-else></td>

                        <td :class="tbl_td_class(pool, ind, row_ind)" 
                                v-if="pool.dhcp_options !== undefined && pool.dhcp_options.ntp[ind] !== undefined"
                                @dblclick="edit_item(pool)">
                            {{ pool.dhcp_options.ntp[ind].ip }}
                        </td>
                        <td :class="tbl_td_class(pool, ind, row_ind)" @dblclick="edit_item(pool)" v-else></td>

                        <td :class="tbl_td_class(pool, ind, row_ind)" 
                                v-if="pool.dhcp_options !== undefined && pool.dhcp_options.nbns[ind] !== undefined"
                                @dblclick="edit_item(pool)">
                            {{ pool.dhcp_options.nbns[ind].ip }}
                        </td>
                        <td :class="tbl_td_class(pool, ind, row_ind)" @dblclick="edit_item(pool)" v-else></td>

                        <td v-if="ind == 0" :class="tbl_td_class_w_name('rc_td_bottom', row_ind)" :rowspan="pool.num_rows">
                            <v-icon small class="me-2" @click="edit_item(pool)">
                                mdi-pencil
                            </v-icon>
                            <v-icon small @click="before_delete_item(pool)">
                                mdi-delete
                            </v-icon>
                        </td>                        
                    </tr>
                </template>
            </tbody>
            </template>
        </v-simple-table>
    </div>
</template>

<script>

import api_client from '../services/api.js';
import vif_ip_addr_box from "../components/vif_ip_addr_box.vue";
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import "../validation_rules.js"

export default {
    name: 'ip_pool',
    components: { 
        ValidationObserver, ValidationProvider, vif_ip_addr_box
    },

    data: () => ({
        deleted_ip_pool_range: {},

        edited_item: {
            dhcp_options: {},
        },
        items: [],
        dialog: false,

        ip_pool_name: '',
        new_ip_pool_dialog: false,

        ip_range_hdrs: [
            { text: 'From IP', value: 'from', align: 'start' },
            { text: 'To IP', value: 'to', sortable: false },
            { text: 'Actions', value: 'actions', sortable: false },
        ],

        server_hdrs: [
            { text: 'IP', value: 'ip', align: 'start' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],

        new_ip_pool_dialog: false,
        ip_pool_name: '',

        new_ip_range_dialog: false,
        to: '',
        from: '',

        new_server_dialog: false,
        server_type: '',
        server_ip: '',
    }),

    created() {
      this.initialize();
    },

    methods: {
        tbl_td_class_w_name(class_name, row_ind) {
            if (row_ind % 2 == 1)
                return class_name + " br_rd_odd";
            return class_name;
        },

        tbl_td_class(rc, ind, row_ind) {
            let add_class = "";

            if (row_ind % 2 == 1) {
                add_class = " br_rd_odd";
            }

            if (ind === rc.num_rows - 1) {
                return "rc_td_bottom" + add_class;
            }

            return "rc_td_no_borders" + add_class;
        },

        calculate_fields() {
            this.items.forEach(pool => {
                let l = 1;

                l = Math.max(l, pool.ip_ranges.length);
                if (pool.hasOwnProperty("dhcp_options")) {
                    l = Math.max(l, pool.dhcp_options.dns.length);
                    l = Math.max(l, pool.dhcp_options.ntp.length);
                    l = Math.max(l, pool.dhcp_options.nbns.length);
                }
                pool["num_rows"] = l;

                /* dhcp options */
                if (!pool.hasOwnProperty("dhcp_options")) {
                    pool["dhcp_options"] = {
                        router: '',
                        mask: '',
                        broadcast: '',
                        mtu: '',
                        lease_time: '',
                        dns: [],
                        ntp: [],
                        nbns: []                    
                    };
                }
            });
        },

        initialize() {
            return new Promise((resolve, reject) => {
                api_client.sh_ip_pools()
                .then(response => {
                    if (response.data.hasOwnProperty("ip_pools")) {
                        this.items = response.data.ip_pools;
                        this.calculate_fields();
                        resolve(response);
                    }
                })
                .catch(error => {
                    console.log(error);
                });
            });
        },

        edit_item(item) {
            this.edited_item = Object.assign({}, item);
            requestAnimationFrame(() => {
                this.$refs.edit_ip_pool_observer.reset();
            });          
            this.dialog = true;
        },

        delete_item() {
            api_client.del_ip_pool({
                name: this.edited_item.name
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    /* success */
                    this.initialize();
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });            
        },

        before_delete_item(item) {
            this.edited_item = Object.assign({}, item);
            this.$confirm("Are you sure you want to delete ip pool '" + item.name + "' ?")
            .then(() => {
                this.delete_item()
            });
        },

        close() {
            this.dialog = false;
            this.initialize();
        },

        show_new_ip_pool_form() {
            this.ip_pool_name = '';
            requestAnimationFrame(() => {
                this.$refs.new_ip_pool_observer.reset();
            });          
            this.new_ip_pool_dialog = true;
        },

        close_new_ip_pool_form() {
            this.new_ip_pool_dialog = false;
        },
        
        update_edited_item() {
            this.items.forEach(item => {
                if (item.name === this.edited_item.name) {
                    this.edited_item = Object.assign({}, item);
                }
            });
        },

        new_ip_pool_form__close() {
            this.new_ip_pool_dialog = false;
        },

        new_ip_pool_form__save() {
            this.$refs.new_ip_pool_observer.validate().then(obs_result => {
                if (!obs_result) {
                    this.$fire({title: "Warning", 
                        text: "Can't save due to invalid field values", type: "warning"});
                    return;
                }

                api_client.add_ip_pool({
                    name: this.ip_pool_name
                })
                .then(response => {
                    if (response.data.hasOwnProperty("err_msg")) {
                        this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                    }
                    else {
                        /* success */
                        this.new_ip_pool_form__close();
                        this.initialize();
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.$fire({title: "Command failed", text: error, type: "warning"});
                });
            });
        },

        ip_range_delete() {
            api_client.del_ip_pool_range({
                name: this.edited_item.name,
                ip_from: this.deleted_ip_pool_range.from,
                ip_to: this.deleted_ip_pool_range.to
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.initialize().then(value => {
                        this.update_edited_item();
                    });
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },

        before_ip_range_delete(item) {
            this.deleted_ip_pool_range = Object.assign({}, item);
            this.$confirm("Are you sure you want to delete ip range " + 
                item.from + " - " + item.to + " ?")
            .then(() => {
                this.ip_range_delete();
            });
        },

        show_ip_range_form() {
            this.from = '';
            this.to = '';
            requestAnimationFrame(() => {
                this.$refs.new_ip_range_observer.reset();
            });
            this.new_ip_range_dialog = true;
        },

        new_ip_range_form__close() {
            this.new_ip_range_dialog = false;
        },

        new_ip_range_form__save() {
            api_client.add_ip_pool_range({
                name: this.edited_item.name,
                ip_from: this.from,
                ip_to: this.to
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.initialize().then(value => {
                        this.update_edited_item();
                        this.new_ip_range_form__close();
                    });
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },

        show_new_server_form(type) {
            this.server_type = type;
            this.server_ip = '';
            requestAnimationFrame(() => {
                this.$refs.new_server_observer.reset();
            });
            this.new_server_dialog = true;
        },

        add_dns() {
            this.show_new_server_form('DNS');
        },

        add_ntp() {
            this.show_new_server_form('NTP');
        },

        add_nbns() {
            this.show_new_server_form('NBNS');
        },

        new_server_form__close() {
            this.new_server_dialog = false; 
        },

        new_server_form__save() {
            api_client.add_pool_server({
                name: this.edited_item.name,
                type: this.server_type.toLowerCase(),
                ip: this.server_ip
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.initialize().then(value => {
                        this.update_edited_item();
                        this.new_server_form__close();
                    });
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        },

        del_server() {
            api_client.del_pool_server({
                name: this.edited_item.name,
                type: this.server_type.toLowerCase(),
                ip: this.server_ip
            })
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.initialize().then(value => {
                        this.update_edited_item();
                    });
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });            
        },

        before_del_server(item, server_type) {
            this.server_type = server_type;
            this.server_ip = item.ip;
            this.$confirm("Are you sure you want to delete " + this.server_type + 
                    " server " + item.ip + " from pool '" + this.edited_item.name + " ' ?")
            .then(() => {
                this.del_server();
            });
        },

        before_del_dns(item) {
            this.before_del_server(item, 'DNS');
        },

        before_del_ntp(item) {
            this.before_del_server(item, 'NTP');
        },

        before_del_nbns(item) {
            this.before_del_server(item, 'NBNS');
        },

        save() {
            let opts = {
                name: this.edited_item.name,
            };

            if (this.edited_item.dhcp_options.router != '') {
                opts["router"] = this.edited_item.dhcp_options.router;
            }
            if (this.edited_item.dhcp_options.mask != '') {
                opts["mask"] = this.edited_item.dhcp_options.mask;
            }
            if (this.edited_item.dhcp_options.lease_time != '') {
                opts["lease_time"] = this.edited_item.dhcp_options.lease_time;
            }
            if (this.edited_item.dhcp_options.broadcast != '') {
                opts["broadcast"] = this.edited_item.dhcp_options.broadcast;
            }
            if (this.edited_item.dhcp_options.mtu != '') {
                opts["mtu"] = this.edited_item.dhcp_options.mtu;
            }

            api_client.set_dhcp_options(opts)
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    this.initialize();
                    this.dialog = false;
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });            
        },
    }
};
</script>
